import '@/assets/css'
import { createApp } from 'vue'
import i18n from './plugins/i18n'
import router from './router'
import store from './store'
import axios from './plugins/axios'
import element from './plugins/element'
import directives from '@/directives'
import App from './App.vue'
import TableButton from './components/Table/install'
import './plugins/ali-arms'
import { globalBury } from './util/useBury'
import microApp from '@micro-zoe/micro-app'
import { getAuth } from './dev'
import { oemUrl } from './views/microapp/const'

microApp.start({
  'router-mode': 'pure',
  preFetchApps: [
    {
      name: 'my-app',
      url: oemUrl
    }
  ]
})

const init = () => createApp(App)
  .use(i18n)
  .use(globalBury)
  .use(store)
  .use(router)
  .use(axios)
  .use(element)
  .use(directives)
  .use(TableButton)
  .mount('#app')

// if (process.env.NODE_ENV === 'development') {
//   getAuth().then(init)
// } else {
//   init()
// }
init()
